
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.266 9.3c-.456.298-1.048.554-1.724.764-.043.014-.082.03-.126.042-.06.02-.126.033-.189.05a14.452 14.452 0 01-1.931.38 16.426 16.426 0 01-2.124.137c-2.462 0-4.798-.526-6.095-1.374-.35-.227-.934-.688-.934-1.217v-1.44c.095.074.2.148.312.22 1.495.976 4.006 1.56 6.717 1.56.338 0 .674-.01 1.005-.028 2.316-.125 4.403-.677 5.71-1.531.113-.073.216-.147.312-.22v1.439c0 .529-.584.99-.933 1.217zm0 3.387c-1.298.849-3.633 1.374-6.094 1.374-2.463 0-4.8-.525-6.095-1.374-.35-.227-.934-.687-.934-1.218v-1.44c.095.075.2.149.312.221 1.495.977 4.006 1.559 6.717 1.559.338 0 .674-.01 1.005-.026 2.316-.125 4.403-.677 5.71-1.532.113-.073.216-.147.312-.22v1.438c0 .53-.584.99-.933 1.218zm.933 2.171c0 1.225-3.005 2.591-7.027 2.591-4.023 0-7.03-1.366-7.03-2.59v-1.441c.096.073.2.148.313.221 1.494.977 4.005 1.558 6.717 1.558 2.71 0 5.22-.58 6.716-1.558.112-.073.215-.146.311-.22v1.44zM8.172 2.101c4.022 0 7.027 1.368 7.027 2.592 0 .53-.584.99-.933 1.219-.456.297-1.048.554-1.724.764-.043.014-.082.03-.126.042-.06.018-.126.032-.189.05a14.458 14.458 0 01-1.931.38 15.824 15.824 0 01-2.124.137c-2.462 0-4.798-.526-6.095-1.373-.35-.229-.934-.689-.934-1.22 0-1.223 3.006-2.59 7.029-2.59zm0-1.136C3.517.965.007 2.567.007 4.693v10.166c0 2.125 3.51 3.727 8.165 3.727 4.653 0 8.163-1.602 8.163-3.728V4.692c0-2.125-3.51-3.727-8.163-3.727z"}})])
          )
        }
      }
    